export { default as createMultiplier } from './createMultiplier';

export type {
  MultiplierRegisterOnSubmitFunction,
  MultiplierRegisterOnSubmitPayload,
} from './createMultiplier.type';
